import React, { useState } from 'react';
import { useTranslation } from '@wix/cli-i18n';
import { useProjectModel } from '../../../model.js';
import { generateDashboardModal } from './generate.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { ChooseFolderStep, ChooseTitleStep } from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateDashboardModal = () => {
  const { t } = useTranslation();
  const { model } = useProjectModel();
  const extensionType = t(
    'generate_command.flow.dashboard_modal'
  ).toLowerCase();

  const [modalFolder, setModalFolder] = useState<string>();
  const [modalTitle, setModalTitle] = useState<string>();

  const modalQuestionsAnswered = modalFolder && modalTitle;

  const generationTask = useGenerationTask(async () => {
    if (!modalQuestionsAnswered) {
      return;
    }

    return generateDashboardModal(model.projectFolder, modalFolder, modalTitle);
  }, [modalQuestionsAnswered]);

  return [
    <ChooseTitleStep onSubmit={setModalTitle} />,
    <ChooseFolderStep
      onSubmit={setModalFolder}
      modalTitle={modalTitle}
      modalFolder={modalFolder}
    />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={extensionType}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        // https://dev.wix.com/docs/build-apps/developer-tools/cli/wix-cli-for-apps/extensions/dashboard-modal-extensions-files-and-code
        learnMoreUrl: 'https://wix.to/zh5ZfMK',
      })}
      route={modalFolder}
    />,
  ];
};
